// NS • Cart
(function () {
  const SELECTOR = '#ns-cart-progress';

  async function fetchCartJSON() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  // Minimal formatter: vervangt {{amount}} varianten in het meegegeven shop-format
  function formatMoney(cents, format) {
    const value = (cents / 100).toFixed(2);
    return String(format || '{{amount}}')
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, value.replace('.', ','))
      .replace(/{{\s*amount_no_decimals\s*}}/g, String(Math.round(cents / 100)))
      .replace(/{{\s*amount\s*}}/g, value);
  }

  function parseThresholds(str) {
    return String(str || '')
      .split(',')
      .map((s) => parseInt(s, 10))
      .filter((n) => Number.isFinite(n) && n > 0);
  }

  // 🔁 Iconen op de balk live wisselen (normaal <-> reached) zonder re-render
  function swapIconsOnBar(root, totalCents, thresholds) {
    const icons = root.querySelectorAll('.goal-icon-onbar');
    if (!icons.length) return;

    icons.forEach((wrap) => {
      const idx0 = (parseInt(wrap.dataset.index, 10) || 1) - 1; // 0-based
      const thr = thresholds[idx0] || Number.POSITIVE_INFINITY;
      const reached = totalCents >= thr;

      const urlRegular = wrap.dataset.regularIcon || '';
      const urlReached = wrap.dataset.reachedIcon || '';
      const img = wrap.querySelector('img');
      if (!img) return;

      const want = reached ? (urlReached || urlRegular) : (urlRegular || urlReached);
      if (want && img.getAttribute('src') !== want) {
        img.setAttribute('src', want);
        img.setAttribute('alt', reached ? `Goal ${idx0 + 1} reached` : `Goal ${idx0 + 1}`);
      }
    });
  }

  async function updateOne(root) {
    if (!root) return;

    const thresholds = parseThresholds(root.dataset.thresholds);
    if (!thresholds.length) return;

    const moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    const useSubtotal = root.dataset.useItemsSubtotal === 'true';

    const cart = await fetchCartJSON();
    if (!cart) return;

    const totalCents = useSubtotal ? cart.items_subtotal_price : cart.total_price;
    const max = thresholds[thresholds.length - 1] || 1;

    // ❗ Floor i.p.v. round, zodat 99.7% geen 100% wordt
    const pct = Math.min(100, Math.floor((totalCents * 100) / max));

    // Bar width + full state
    const bar = root.querySelector('#cart-progress-bar, .ns-cart-progress__bar');
    if (bar) bar.style.width = pct + '%';

    // Voltooid alleen wanneer het laatste doel echt is behaald
    root.classList.toggle('is-full', totalCents >= max);

    // Message swap
    const preMsgs = (root.dataset.preGoalMessages || '').split('||');
    const postMsgs = (root.dataset.postGoalMessages || '').split('||');

    let nextIdx = -1;
    for (let i = 0; i < thresholds.length; i++) {
      if (totalCents < thresholds[i]) {
        nextIdx = i;
        break;
      }
    }

    const msgEl = root.querySelector('.ns-cart-progress__message, .goal-message');
    if (msgEl) {
      if (nextIdx === -1) {
        msgEl.textContent = (postMsgs[postMsgs.length - 1] || '').trim();
      } else {
        const remain = Math.max(0, thresholds[nextIdx] - totalCents);
        const remainFmt = formatMoney(remain, root.dataset.moneyFormat || '{{amount}}');
        const tpl = preMsgs[nextIdx] || '';
        msgEl.textContent = tpl.replace('[x]', remainFmt);
      }
    }

    // 🔁 Iconen live wisselen
    swapIconsOnBar(root, totalCents, thresholds);
  }

  async function updateAll() {
    const roots = document.querySelectorAll(SELECTOR);
    if (!roots.length) return;
    for (const root of roots) {
      await updateOne(root);
    }
  }

  // Initial run (ook als DOM al klaar is)
  updateAll();
  document.addEventListener('DOMContentLoaded', updateAll);

  // Shopify events die vaak afgaan bij cart/sections changes
  ['cart:updated', 'cart:refresh', 'ajaxProduct:added', 'shopify:section:load', 'shopify:section:select', 'shopify:section:reorder']
    .forEach((evt) => document.addEventListener(evt, updateAll));

  // Fallback: observe cart drawer mutaties (als thema geen events dispatcht)
  function attachDrawerObserver() {
    const dlg = document.querySelector('cart-drawer-component dialog[ref="dialog"]');
    if (dlg && 'MutationObserver' in window) {
      const obs = new MutationObserver(() => updateAll());
      obs.observe(dlg, { attributes: true, childList: true, subtree: true });
    }
  }
  attachDrawerObserver();

  // Expose manual trigger
  window.NS_updateCartProgress = updateAll;
})();
